import { IndexedObject } from 'services/indexedObject';

export type OptionsContractType = {
  // real-world contracts coming from options-db
  id: number;
  underlying_fk: number;
  strike: number;
  quote_date: string;
  expiration: string;
  type_int: number; // put / call
  bid: number;
  ask: number;
  volume: number;
  open_interest: number;
  delta: number;
  gamma: number;
  theta: number;
  vega: number;
  implied_volatility: number;
};

export type PlayerOptionsContractType = {
  id: number;
  options_instrument: number;
  contract_type: number;
  premium: number;
  open_price: number;
  close_price: number;
  close_spot: number;
  current_bid: number;
  current_ask: number;
  open_iv: number;
  current_iv: number;
  current_delta: number;
  strike: number;
  transaction: number;
  contracts: number;
  quote_date: string;
  expiration_date: string;
  options_db_contract_id: number;
  timestamp: string;
  closing_timestamp: string;
  status: number;
  pnl: number; // saved only after exercise / write / worthless
  intrinsic_pnl: number; // same
  delta_hedge_pnl: number; // same
  overall_pnl: number; // same
};

export type PartialPlayerOptionsContractType = {
  id: number;
  current_bid: number;
  current_ask: number;
  current_iv: number;
  current_delta: number;
};

export type PartialOptionsInstrument = {
  id: number;
  options_contracts: PartialPlayerOptionsContractType[];
};

export type OptionsContractsDetailsType = {
  contracts: OptionsContractType[];
  underlying_spot: number;
  expiration_dates: string[];
};

export type OptionsContractsData = {
  of_asset: IndexedObject<OptionsContractsDetailsType>; // indexed by options asset id
  fetching: boolean;
  fetched: boolean;
};

export const OptionsContractsDataInitialState: OptionsContractsData = {
  of_asset: {} as IndexedObject<OptionsContractsDetailsType>,
  fetching: false,
  fetched: false,
};

export type OptionsInstrumentType = {
  id: number;
  options_asset: number;
  options_contracts: IndexedObject<PlayerOptionsContractType>;
};

export type OptionsInstrumentsType = {
  items: IndexedObject<OptionsInstrumentType>;
  fetched: boolean;
  fetching: boolean;
};

export const OptionsInstrumentsInitialState: OptionsInstrumentsType = {
  items: {} as IndexedObject<OptionsInstrumentType>,
  fetching: false,
  fetched: false,
};
